// UTC-anchored date helpers for the trade-invoice forms: native date inputs
// hold YYYY-MM-DD strings, the wire carries the same, and Date round-trips pin
// to midnight UTC so a render in any timezone shows the stored calendar day.

export function isoDateValue(d: Date): string {
  const yyyy = String(d.getUTCFullYear());
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function parseIsoDate(iso: string): Date {
  return new Date(`${iso}T00:00:00.000Z`);
}

export function todayIso(now: () => Date = () => new Date()): string {
  return isoDateValue(now());
}
